import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/client/Company/CareersPage/CareersPage.tsx");
